module.exports = __webpack_public_path__ + "static/media/Square2.d06c49f3.png";